// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__i3yUi","back_icon":"NavigationTitle_back_icon__tpr3L","text_container":"NavigationTitle_text_container__Cctns"};